import { gql } from '@apollo/client';

export const COMPANY_BASE_FIELDS = gql`
  fragment CompanyBaseFields on Company {
    id
    active
    name
    configuration
    subscription
  }
`;
